import { Chart } from 'chart.js';

import getGeneList from './components/genes/selectgenes.js';
import getPatientList from './components/patients/selectAnon.js';
import getSymptomList from './components/symptoms/selectsymptoms.js';
//import { mystore } from './store.js';
import pattern from './node_modules/patternomaly/dist/patternomaly.js'

//app
const URL='http://54.152.206.84:8000/';

//patterns and colors

const colors = ["red","aqua","orange","green","pink", "purple", "darkred", "brown", "darkblue"];

//infection
const infectList = ["Bocavirus", 'Bocavirus_WUPolyomavirus', 'Coronavirus 229E', 'Coronavirus 229E_Coronavirus OC43', 'Coronavirus 229E_Rhinovirus', 'Coronavirus HKU1', 'Coronavirus NL63', 'Coronavirus NL63_Respiratory syncytial virus B', 'Coronavirus OC43', 'Coronavirus OC43_Rhinovirus', 'Coronavirus OC43_WUPolyomavirus', 'Coronavirus OC43_Adenovirus_WUPolyomavirus', 'Coronavirus OC43_Rhinovirus', 'Coxackievirus', 'Enterovirus', 'Influenza A', 'Influenza A_Rhinovirus', 'Influenza B', 'Influenza C', 'Parainfluenza 2', 'Parainfluenza 4', 'RSVB_RhinovirusC_CoronavirusHKU1_ADC_WUPolyomavirus', 'Respiratory syncytial virus', 'Respiratory syncytial virus A', 'Respiratory syncytial virus B', 'Rhinovirus', 'Rhinovirus_Coronavirus OC43', 'Rhinovirus_Coronavirus229E'];
//infectList also defined in virus_plot bc it's not being recognized here

//symptoms
const allSymptoms = ["fever", "chills", "musclepain", "wateryeye", "runnynose", "sneezing", "sorethroat", "cough", "chestpain"]
const prettySymptoms  = ["Fever", "Chills", 'Muscle Pain', 'Watery Eye', 'Runny Nose', 'Sneezing', 'Sore Throat', 'Cough', "Chest Pain"]

getGeneList();
getPatientList();
getSymptomList();
